import { render, staticRenderFns } from "./addAdminSideBar.vue?vue&type=template&id=0862cdc1&scoped=true&"
import script from "./addAdminSideBar.vue?vue&type=script&lang=js&"
export * from "./addAdminSideBar.vue?vue&type=script&lang=js&"
import style0 from "./addAdminSideBar.vue?vue&type=style&index=0&id=0862cdc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0862cdc1",
  null
  
)

export default component.exports